import * as React from "react"

function SquareCheckOff(props) {
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M16.6667 2H3.33333C2.97971 2 2.64057 2.14048 2.39052 2.39052C2.14048 2.64057 2 2.97971 2 3.33333V16.6667C2 17.0203 2.14048 17.3594 2.39052 17.6095C2.64057 17.8595 2.97971 18 3.33333 18H16.6667C17.0203 18 17.3594 17.8595 17.6095 17.6095C17.8595 17.3594 18 17.0203 18 16.6667V3.33333C18 2.97971 17.8595 2.64057 17.6095 2.39052C17.3594 2.14048 17.0203 2 16.6667 2ZM3.33333 16.6667V3.33333H16.6667V16.6667H3.33333Z" fill="#8896A9" />
    </svg>

  )
}

export default SquareCheckOff